"use strict";

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadResponseTypeError = exports.TypeMismatchError = exports.NoUniqueBestOverloadError = exports.NoOverloadsMatchedError = void 0;

var Format = __importStar(require("../format"));
/**
 * This error indicates that no overloads matched when performing
 * overload resolution.  If there was only one plausible match,
 * a [[TypeMismatchError]] will be thrown instead.
 * @category Errors
 */


var NoOverloadsMatchedError = /*#__PURE__*/function (_Error) {
  _inherits(NoOverloadsMatchedError, _Error);

  var _super = _createSuper(NoOverloadsMatchedError);

  function NoOverloadsMatchedError(methods, inputs, userDefinedTypes) {
    var _this;

    _classCallCheck(this, NoOverloadsMatchedError);

    var message = "Arguments provided did not match any overload";
    _this = _super.call(this, message);
    _this.methods = methods;
    _this.inputs = inputs;
    _this.userDefinedTypes = userDefinedTypes;
    _this.name = "NoOverloadsMatchedError";
    return _this;
  }

  return _createClass(NoOverloadsMatchedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.NoOverloadsMatchedError = NoOverloadsMatchedError;
/**
 * This error indicates that multiple overloads matched during
 * overload resolution, but none of them was the unique best
 * overload.
 * @category Errors
 */

var NoUniqueBestOverloadError = /*#__PURE__*/function (_Error2) {
  _inherits(NoUniqueBestOverloadError, _Error2);

  var _super2 = _createSuper(NoUniqueBestOverloadError);

  function NoUniqueBestOverloadError(resolutions) {
    var _this2;

    _classCallCheck(this, NoUniqueBestOverloadError);

    var message = "Could not determine a unique best overload for the given arguments.  " + "Please specify the overload explicitly or give the arguments more explicit types.";
    _this2 = _super2.call(this, message);
    _this2.resolutions = resolutions;
    _this2.name = "NoUniqueBestOverloadError";
    return _this2;
  }

  return _createClass(NoUniqueBestOverloadError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.NoUniqueBestOverloadError = NoUniqueBestOverloadError;
/**
 * This error indicates that the given input could not be recognized as the
 * type it was supposed to be.
 * @category Errors
 */

var TypeMismatchError = /*#__PURE__*/function (_Error3) {
  _inherits(TypeMismatchError, _Error3);

  var _super3 = _createSuper(TypeMismatchError);

  function TypeMismatchError(dataType, input, variableName, specificity, reason) {
    var _this3;

    _classCallCheck(this, TypeMismatchError);

    var message = "Could not interpret input for ".concat(variableName, " as type ").concat(Format.Types.typeString(dataType), ".  Reason: ").concat(reason);
    _this3 = _super3.call(this, message);
    _this3.variableName = variableName;
    _this3.dataType = dataType;
    _this3.input = input;
    _this3.reason = reason;
    _this3.specificity = specificity;
    _this3.name = "TypeMismatchError";
    return _this3;
  }

  return _createClass(TypeMismatchError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.TypeMismatchError = TypeMismatchError;

var BadResponseTypeError = /*#__PURE__*/function (_Error4) {
  _inherits(BadResponseTypeError, _Error4);

  var _super4 = _createSuper(BadResponseTypeError);

  function BadResponseTypeError(request, response) {
    var _this4;

    _classCallCheck(this, BadResponseTypeError);

    var message = "Got response type ".concat(response.kind, " to request type ").concat(request.kind);
    _this4 = _super4.call(this, message);
    _this4.request = request;
    _this4.response = response;
    _this4.name = "BadResponseTypeError";
    return _this4;
  }

  return _createClass(BadResponseTypeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.BadResponseTypeError = BadResponseTypeError;